export const visit = (vm, at) => {
at({ "de": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Neue Nachricht" } } } });
};